import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../services/storage.service';

const AUTH_TOKEN_KEY = 'authToken';

export function isAuthenticated(storageService: StorageService): boolean {
  let token: string | null = null;
  try {
    token = storageService.getItem<string>(AUTH_TOKEN_KEY);
  } catch {
    return false;
  }

  if (!token) {
    return false;
  }

  if (isTokenExpired(token)) {
    storageService.clear();
    return false;
  }

  return true;
}

// Blocks private pages for logged-out users (typed URL, back/forward, new tab).
export const authGuard: CanActivateFn = () => {
  const storageService = inject(StorageService);
  const router = inject(Router);

  return isAuthenticated(storageService) ? true : router.createUrlTree(['/login']);
};

// Keeps logged-in users away from login/OTP pages, including via the browser back button.
export const guestGuard: CanActivateFn = () => {
  const storageService = inject(StorageService);
  const router = inject(Router);

  return isAuthenticated(storageService) ? router.createUrlTree(['/dashboard']) : true;
};

function isTokenExpired(token: string): boolean {
  try {
    const payload = token.split('.')[1];
    if (!payload) {
      return false;
    }

    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const { exp } = JSON.parse(atob(base64)) as { exp?: number };
    return typeof exp === 'number' && exp * 1000 <= Date.now();
  } catch {
    return false;
  }
}
